import { styled } from '@mui/material/styles';
import { Button, ButtonProps } from '@mui/material';

export const MainButtonComponent = styled(Button)<ButtonProps>(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'max-content',
    padding: '4px 18px',
    borderRadius: '4px',
    cursor: 'pointer',
    color: theme.palette.customText.text4,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '28px',
    textAlign: 'center',
    '&:hover': {
        borderRadius: '4px',
    },
}));
